import React from 'react';
import { styled } from 'styled-components';
import IntegrationPreview from './IntegrationPreview.js';
const Integrations = (props) => {
    const integrations = props.integrations;
    return (React.createElement(Wrapper, null, integrations.map((integration) => (React.createElement(IntegrationPreview, { key: integration.id, href: typeof props.genLink === 'function'
            ? props.genLink(integration)
            : undefined, integration: integration })))));
};
const Wrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
export default Integrations;
//# sourceMappingURL=Integrations.js.map